import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { GetProfileDataTypes } from "../../../../Schema/getProfile.types";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { alert } from "../../../../Utils/toast";
import { call } from "@redux-saga/core/effects";
import { queryClient } from "../../../store";

import i18n from "../../../../i18next";

export type GetProfileLoadAction = {
  type: string;
  payload: Record<string, never>;
};

export type GetProfileData = {
  data: GetProfileDataTypes;
};

const GetProfile = new ReduxFetchState<GetProfileData | null, Record<string, never>, any>(
  "getProfile",
);

export function* watchGetProfile(_: GetProfileLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: GetProfileData = yield call([queryClient, queryClient.fetchQuery], {
      queryKey: ["getProfile", lang],
      queryFn: async () => {
        const res = await axios({
          url: "/api/v1/users/ai/profile/details",
          method: "GET",
          headers: { lang },
        });
        return { data: res.data };
      },
      staleTime: 5 * 60 * 1000,
    });

    yield put(GetProfile.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {
    alert({
      //@ts-ignore
      message: i18n.t("errors.getProfileError"),
      type: "error",
    });

    yield put(GetProfile.actions.loadFailure(e?.response?.data));
  }
}

export function* getProfileSagas() {
  yield takeEvery(GetProfile.actionTypes.load, watchGetProfile);
}

export function useGetProfile() {
  const { loading, data, ...getProfileState } = useAppSelector((state) => state.getProfile);
  const dispatch = useAppDispatch();

  const dispatchGetProfile = useCallback(() => {
    dispatch(GetProfile.actions.load({}));
  }, [dispatch]);

  return {
    ...getProfileState,
    dispatchGetProfile,
    getProfileLoading: loading,
    getProfileData: data,
  };
}

export const {
  actionTypes: getProfileActionsTypes,
  actions: getProfileActions,
  reducer: getProfileReducer,
} = GetProfile;
